import { render, staticRenderFns } from "./BranchProductStockList.vue?vue&type=template&id=b595ac9c&"
import script from "./BranchProductStockList.vue?vue&type=script&lang=js&"
export * from "./BranchProductStockList.vue?vue&type=script&lang=js&"
import style0 from "./BranchProductStockList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports